<template>
    <div class="event_management mainBody">
        <div class="input_area">
            <div class="input_box">
                <div class="box_top">
                    <div class="input_group" v-if="groupList.item1.isShow">
                        <label v-if="groupList.item1.selectOrinput" class="input_label" for="select">{{groupList.item1.label}}</label>
                        <el-select v-if="groupList.item1.selectOrinput" id="select" class="inputInner" v-model="groupList.item1.value" placeholder="请选择">
                            <el-option
                            v-for="item in groupList.item1.selectOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <label v-if="!groupList.item1.selectOrinput" class="input_label" for="input">{{groupList.item1.label}}</label>
                        <el-input v-if="!groupList.item1.selectOrinput" id="input" class="inputInner" v-model="groupList.item1.value" placeholder="请输入内容"></el-input>
                    </div>
                    <div class="input_group" v-if="groupList.item2.isShow">
                        <label v-if="!groupList.item2.selectOrinput" class="input_label" for="input">{{groupList.item2.label}}</label>
                        <el-input v-if="!groupList.item2.selectOrinput" id="input" class="inputInner" v-model="groupList.item2.value" placeholder="请输入内容"></el-input>
                    </div>
                </div>
            </div>
            <div class="add_box">
                <button @click='submit' class="formButton add_btn_event" >添加</button>
            </div>
        </div>
        <div class="table_area">
                <el-checkbox-group v-model="checkedEvents" @change="handleCheckedEventsChange">
                    <el-checkbox  v-for="event in eventOptions" :label="event.value"  :key="event.value">{{event.label}}</el-checkbox> 
                </el-checkbox-group>
        </div>
         <div class="newInput_group" v-if="isIndeterminate ">
                <div class="div1"><button @click='openAmend' class="formButton edit_btn_event">修改</button></div>
                    <div><el-input id="input" class="newInput_inner"  placeholder="请输入内容" v-model="editValue"></el-input></div>
                <div class="div2"><button @click='openDelete' class="formButton delete_btn_event">删除</button></div>
            </div>
    </div>
</template>

<script>
// import css from '@/css/form.css'
import API from '@/api/material.js'

export default {
    name:'event_management',
    data(){
        return{
            checkAll: false,
            checkedEvents: [],
            eventOptions:[],
            isIndeterminate: false,
            value:'',
            editValue:null,
            groupList:{
                item1:{
                    isShow:true,
                    selectOrinput:true, //1 select 0 input
                    label:'选择事件类型',
                    selectOptions:[
                        {
                            value:'',
                            label:''
                        },
                    ],
                    placeHolder:'',
                    value:null,
                },
                item2:{
                    isShow:true,
                    selectOrinput:false, //1 select 0 input
                    label:'添加事件',
                    selectOptions:[
                        {
                            value:'',
                            label:''
                        },
                    ],
                    placeHolder:'',
                    value:null,
                },
                length:2
            },
            boxBottom:{
                isBoxBottom:true,
                 input:'',
                 label:'备注'
                
            },
            tableData: [],
            AllClass:this.$store.state.AllClass
        }
    },
    computed:{
        eventModuleId(){
            return this.$store.state.eventModuleIds.qulity
        }
    },
    methods:{
        handleCheckAllChange(val) {
            this.checkedEvents = val ? this.eventOptions : [];
            this.isIndeterminate = false;
        },
        handleCheckedEventsChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.eventOptions.length;
            this.isIndeterminate = checkedCount > 0 ;
            if(this.checkedEvents.length > 1){
                this.checkedEvents.splice(0,1)
            }
            this.editValue = (this.eventOptions.find(item=>item.value == value[0])).label
        },
        amend(){
            //action=update&eventmoduleid=1&eventtypeid=1&detail=22222&id=3
            let list = this.eventOptions.find(item=>item.value == this.checkedEvents[0]);
            let param = {
                action:'update',
                eventmodule_id:list.eventmodule_id,
                eventtype_id:list.eventtype_id,
                detail:this.editValue,
                id:list.value
                
            }
            return new Promise((resolve,reject)=>{
                API.getModuleManagement(param).then((res)=>{
                    resolve(res)
                }).catch((err)=>{
                    console.log(err);
                    resolve(0)
                })
            })
            
        },
        delete(){
            let list = this.eventOptions.find(item=>item.value == this.checkedEvents[0]);
            let param = {
                action:'delete',
                id:list.value  
            }
            return new Promise((resolve,reject)=>{
                API.getModuleManagement(param).then((res)=>{
                    resolve(res)
                }).catch((err)=>{
                    console.log(err);
                    resolve(0)
                })
            })
            
        },
        addMethod(){
            // action=add&eventName=风水不符&detail=不能说的秘密&eventmodule_id=1

            let list = this.groupList;
                let tmpValue ={
                    action:'add',
                    eventtype_id:list.item1.value||'',
                    detail:list.item2.value||'',
                    eventmodule_id:this.eventModuleId||''
                };
             return new Promise((resolve,reject)=>{
                    API.getModuleManagement(tmpValue).then(res=>{
                        console.log('res',res);
                        resolve(res)
                    }).then(()=>{
                        this.synchrodata();
                    }).catch((err)=>{
                        console.log(err);
                        resolve(0)
                    })
                })
                
                
                
        },
        open() {
            this.$confirm('是否确认添加, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                this.addMethod().then((message)=>{
                    if(message != 0){
                        this.$message({
                        message: '添加成功',
                        type: 'success'
                        });
                    }else{
                        this.$message({
                        message: '添加失败，请稍后再试',
                        type: 'error'
                        });
                    }
                })
            })
            .catch(() => {
            this.$message({
                type: 'info',
                message: '已取消添加'
            });          
            });
        },
        openAmend(index,row) {
            this.$confirm('是否确认修改, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                this.amend().then((message)=>{
                    if(message != 0){
                        this.$message({
                        message: '修改成功',
                        type: 'success'
                        });
                        this.synchrodata();
                    }else{
                        this.$message({
                        message: '修改失败，请稍后再试',
                        type: 'error'
                        });
                    }
                })
               
            }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消修改'
            });          
            });
        },
        openDelete(index,row) {
            this.$confirm('是否确认删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                this.delete().then((message)=>{
                    if(message != 0){
                        this.$message({
                        message: '删除成功',
                        type: 'success'
                        });
                        this.checkedEvents = [];
                        this.editValue =null;
                        this.synchrodata();
                    }else{
                        this.$message({
                        message: '删除失败，请稍后再试',
                        type: 'error'
                        });
                    }
                })
               
            }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消修改'
            });          
            });
        },
        synchrodata(){  
                    this.getGroupList();
                    this.getTableList();
        },
        submit(){
            if(!this.verifyMainLabel()){
                this.$message({
                    message: '请填写完整参数',
                    type: 'warning'
                    });
                return
            }else{
                this.open()
              
            } 
        },
        verifyMainLabel() {
            let result = true;
           for(var i = 1;i <= this.groupList.length;i++){

                if(`${this.groupList[`item${i}`].value}` == '' ||this.groupList[`item${i}`].value == null){
                    result = false;
                }
            }
            return result
        },
        formatEventTypeList(lists){
            let tmpList = [];
            let list = lists?lists:[];
            for(var i = 0; i <list.length;i++){
                tmpList.push({
                    value:list[i].id,
                    label:list[i].eventName,
                })
            }
            return tmpList

        },
        fprmatTableList(lists){
            let tmpList = [];
            let list = lists?lists:[];
            for(var i = 0; i <list.length;i++){
                tmpList.push({
                    value:list[i].id,
                    label:list[i].detail,
                    eventtype_id:list[i].eventtype_id,
                    eventmodule_id:list[i].eventmodule_id,
                })
            }
            return tmpList
        },
        getGroupList(){
            let param ={
                action:this.$store.state.API_params.action,
                eventmodule_id:this.eventModuleId
            };
            API.getModuleEvents(param).then((res)=>{
                let list =res.message.obj;
                this.groupList.item1.selectOptions=this.formatEventTypeList(list);
            }).catch(err=>{
                console.log(err);
            })
        },
        getTableList(){
            let param ={
                action:this.$store.state.API_params.action,
                eventmodule_id:this.eventModuleId
            };
            API.getModuleManagement(param).then((res)=>{
                let list =res.message.obj;
                let tempList = this.fprmatTableList(list);
                this.eventOptions = [];
                for(var i = 0;i<tempList.length;i++){
                this.eventOptions.push(tempList[i]) ;
                }
            }).catch(err=>{
                console.log(err);
            })
        }
    },
    mounted(){
        this.synchrodata();
    }
}
</script>

<style scoped>
.event_management{
    height: 100%;
    width: 90%;
    margin: 0 auto;
}

.newInput_group{
    height: 35%;
    display: flex;
    width: 100%;
    margin-top: 2%;
}

.newInput_group div{
    width: calc(100%/3);
    height: 20%;
}
.div1{
    display: flex;
    justify-content: flex-end;
    padding-right: 5%;
    align-items: center;
    color: var(--subject--title);
}
.div2{
    display: flex;
    align-items: center;
    padding-left: 5%;
}

.el-checkbox{
    margin-left: 15px;
    margin-top: 15px;
    width: 29%;
}
.el-checkbox__label{
    width: 100%;
    height: 100%;
    overflow: hidden;
}
.el-checkbox-group{
    height: 100%;
    width: 100%;
}
.innerInput{
    border: none;
    border-radius: var(--border--radius);
    background-color: var(--subject--input);
    transition: var(--subject--transition);
    color:var(--subject--text) ;
    width: 50%;
    cursor: pointer;
}
.add_box{
    width: 20%;
    height: 80%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.add_btn_event{
    width: 45%;
    height: 50%;
}
.input_area{
    margin-top: 1%;
    height: 16%;
    width: 100%;
    display: flex;
}
.input_group {
    width: 50%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-content: center;
}
.newInput_inner{
    width: 100% !important;
}
.delete_btn_event{
    height: 90%;
    width: 20%;
    background-color: var(--subject--delete_btn);
}
.edit_btn_event{
    height: 90%;
    width: 20%;
    background-color: var(--subject--botton);
}
.edit_btn_event:hover{
   background-color: #1e329a;
}

.delete_btn_event:hover{
    background-color: #f54747;
}

</style>>


